import React, { useState, useEffect } from 'react';
import './Header.scss';
import { motion } from 'framer-motion';

import { images } from '../../constants';
import { AppWrap } from '../../wrapper';


const scaleVariants = {
  whileInView :{
    scale : [0,1],
    opacity : [0,1],
    transition : {
      duration : 1,
      ease : 'easeInOut'
    }
  }
}




const Header = () => {

  const [currentTagIndex, setCurrentTagIndex] = useState(0);
  const tags = ['Computer Engineer 💴', 'JAVA Developer🍵', 'MERN Stack Developer💲', 'FreeLancer💯', 'Python Developer🐍', 'Data Analyst📅', 'AIML Enthusiast💯'];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTagIndex((prevIndex) => (prevIndex + 1) % tags.length);
    }, 2000);

    return () => clearInterval(timer);
  }, [tags.length]);


  return (
    <div className='app__header app__flex'>
      <motion.div
      whileInView={{ x: [-100, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
      className="app__header-info"
      
    >
      <div className='app__header-badge'>
        <div className='badge-cmp app__flex'>
          <span>👋</span>

          <div style={{ marginLeft: 20 }}>
            <h4 className='p-text'>Hey there!, I am</h4>
            <h1 className='head-text'>Er.GOVINDA CHASTWE</h1>
          </div>
        </div>

        <div className='tag-cmp app__flex' style={{ marginLeft: 50, height:70}}>
          <h5 className='p-text'>{tags[currentTagIndex]}</h5>
        </div>
      </div>
    </motion.div>

      <motion.div
        whileInView={{opacity:[0,1]}}
        transition={{duration:0.5, delayChildren: 0.5}}
        className="app__header-img"
      >
        <img src={images.profile} alt="profile_bg" />
        <motion.img
          whileInView={{scale:[0,1]}}
          transition={{duration:1, delayChildren: 'easeInOut'}}
          className="overlay_circle"
          src={images.circle}
          alt="profile_circle"

        />
      </motion.div>


      <motion.div 
        variant={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className = "app__header-circles"
      >
        {[images.python, images.java, images.react].map((circle, index) =>(
          <div className="circle-cmp app__flex" key={`circle-${index}`}>
            <img src={circle} alt="circle" />
          </div>
        ))}
      </motion.div>
    </div>
  )
}

export default AppWrap(Header, 'home');